import { render, staticRenderFns } from "./CarteIdentification.vue?vue&type=template&id=b0f0ab04"
import script from "./CarteIdentification.vue?vue&type=script&lang=js"
export * from "./CarteIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports